// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__jNSqN","title":"BackImages_title__25TYA","images":"BackImages_images__2sJe6"};